'use client';

// Third Party Plugins
import React from 'react';
// Utilities
import { capitalizeEachWord } from '@utils/capitalizeEachWord';
// Styles
import { ListContainer, BookItem } from './styles';
// Custom Components
import MediumCard from '@/components/cards/MediumCard';
import CardGridContainer from '@/components/cards/CardGridContainer';
import { Book } from '../../types';
import { BookListProps } from './types';

const BookList: React.FC<BookListProps> = ({ books, isGrid }) => {
  return isGrid ? (
    <CardGridContainer>
      {books.map((b: Book) => (
        <MediumCard
          _id={b._id}
          cardType={b._type}
          key={b._id}
          title={b.title}
          author={b.author}
          publisher={b.publisher}
          isbn={b.isbn}
          dateOfPublication={b.dateOfPublication}
          category={
            b.category
              ? b.category.map(capitalizeEachWord).join(', ')
              : 'Unknown Category'
          }
          href={`/books/${b.slug.current}`}
        />
      ))}
    </CardGridContainer>
  ) : (
    <ListContainer>
      {books.map((b: Book) => (
        <BookItem key={b._id}>
          <h3>{b.title}</h3>
          <p>
            <strong>Author:</strong> {b.author}
          </p>
          <p>
            <strong>Publisher:</strong> {b.publisher || 'Unknown'}
          </p>
          <p>
            <strong>ISBN:</strong> {b.isbn || 'N/A'}
          </p>
          <p>
            <strong>Category:</strong>{' '}
            {b.category?.map(capitalizeEachWord).join(', ') ||
              'Unknown Category'}
          </p>
          <p>
            <strong>Date of Publication:</strong> {b.dateOfPublication}
          </p>
          <a href={`/books/${b.slug.current}`} style={{ color: 'blue' }}>
            View Details
          </a>
        </BookItem>
      ))}
    </ListContainer>
  );
};

export default BookList;
